import { yellow, error, rating4 } from "styles/theme"
import constants from "./constants"

const useErrorTypeList = () => {

    const errorList = [
        {
            label: constants.error,
            borderColor: error
        },
        {
            label: constants.errorWithSelfCorrection,
            borderColor: error,
            borderStyle: "dashed"
        },
        {
            label: constants.minorError,
            borderColor: rating4
        },
        {
            label: constants.minorErrorWithSelfCorrection,
            borderColor: rating4,
            borderStyle: "dashed"
        },
        {
            label: constants.selfCorrection,
            borderColor: yellow,
            borderStyle: "dashed"
        },
        {
            label: constants.omission,
            borderColor: "transparent",
            borderStyle: "dashed",
            opacity: true
        },
        {
            label: constants.omissionAndError,
            borderColor: error,
            opacity: true
        },
        {
            label: constants.omissionAndMinorError,
            borderColor: rating4,
            borderStyle: "dashed",
            opacity: true
        },
    ]

    return errorList
}

export default useErrorTypeList